var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.1763,
    cy: 7.1763,
    r: 6.1763,
    stroke: "#99A8B2",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8736 13.2856L11.3127 12.4577L9.65688 13.5795L10.2178 14.4074L11.8736 13.2856ZM13.8628 19.7877C14.1725 20.2449 14.7943 20.3645 15.2516 20.0547C15.7088 19.7449 15.8283 19.1231 15.5186 18.6659L13.8628 19.7877ZM10.2178 14.4074L13.8628 19.7877L15.5186 18.6659L11.8736 13.2856L10.2178 14.4074Z",
    fill: "#99A8B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.327f3a06ab9eb9cf1e2aa66fcfcda624.svg";
export { ForwardRef as ReactComponent };